import { get, post } from './http';

export const getOrganizations = async (channelId) => {
  const response = await get(
    `/api/shoppinglist/getorganizations?channelId=${channelId}`
  );
  return response.json();
};

export const postInquire = async (body, isConfigurator = false) => {
  const response = await post(isConfigurator ? '/api/configurator/sendinquire' : '/api/shoppinglist/sendinquire', body);
  return response.status == 200;
};